import React from "react";
import { useTranslation } from "react-i18next";
import FloorMapSettings from "~/components/FloorMapSettings";
import Accordion from "~/components/utils/Accordion";

/**
 * フロアマップ設定セクションコンポーネント
 * @returns フロアマップ設定セクションのJSX要素
 */
const FloorMapSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: `${t("floorMap")}`,
          content: <FloorMapSettings />,
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default FloorMapSection;
